import { Map } from 'immutable';

import LogsMyFhe from './scenes/LogsMyFhe';
import LogsCocoon from './scenes/LogsCocoon';
import LogsFhe from './scenes/LogsFhe';
import LogsFHEConnect from './scenes/LogsFHEConnect';
import LogsFHEPool from './scenes/LogsFHEPool';
import LogsHoming from './scenes/LogsHoming';
import LogsLacin from './scenes/LogsLacin';
import LogsDomalisa from './scenes/LogsDomalisa';
import LogsAccesshabitat from './scenes/LogsAccesshabitat';
import LogsMaestro from './scenes/LogsMaestro';
import LogsWeezeo from './scenes/LogsWeezeo';
import LogsNiceenergie from './scenes/LogsNiceenergie';
import LogsMghabitat from './scenes/LogsMghabitat';
import LogsInogreen from './scenes/LogsInogreen';

export default new Map({
    /** Logging Fhe */
    '/fhe': {
        firstPage: true,
        right: 'logging_fhe',
        must_logged: true,
        component: LogsFhe,
    },
    /** Logging MyFhe */
    '/myfhe': {
        // firstPage: true,
        right: 'logging_myfhe',
        must_logged: true,
        component: LogsMyFhe,
    },
    /** Logging Cocoon */
    '/cocoon': {
        // firstPage: true,
        right: 'logging_cocoon',
        must_logged: true,
        component: LogsCocoon,
    },
    /** Logging FHEConnect */
    '/fheconnect': {
        // firstPage: true,
        right: 'logging_fheconnect',
        must_logged: true,
        component: LogsFHEConnect,
    },
    /** Logging FHEPool */
    '/fhepool': {
        right: 'logging_fhepool',
        must_logged: true,
        component: LogsFHEPool,
    },
    /** Logging Homing */
    '/homing': {
        right: 'logging_homing',
        must_logged: true,
        component: LogsHoming,
    },
    /** Logging Lacin */
    '/lacin': {
        right: 'logging_lacin',
        must_logged: true,
        component: LogsLacin,
    },
    /** Logging Domalisa */
    '/domalisa': {
        right: 'logging_domalisa',
        must_logged: true,
        component: LogsDomalisa,
    },
    /** Logging Accesshabitat */
    '/accesshabitat': {
        right: 'logging_accesshabitat',
        must_logged: true,
        component: LogsAccesshabitat,
    },
    /** Logging Maestro */
    '/maestro': {
        right: 'logging_maestro',
        must_logged: true,
        component: LogsMaestro,
    },
    /** Logging Weezeo */
    '/weezeo': {
        right: 'logging_weezeo',
        must_logged: true,
        component: LogsWeezeo,
    },
    /** Logging Niceenergie */
    '/niceenergie': {
        right: 'logging_niceenergie',
        must_logged: true,
        component: LogsNiceenergie,
    },
    /** Logging Mghabitat */
    '/mghabitat': {
        right: 'logging_mghabitat',
        must_logged: true,
        component: LogsMghabitat,
    },
    /** Logging Inogreen */
    '/inogreen': {
        right: 'logging_inogreen',
        must_logged: true,
        component: LogsInogreen,
    },
});



// WEBPACK FOOTER //
// ./environments/logging/routes.js